import { render, staticRenderFns } from "./LinkCopyButton.vue?vue&type=template&id=09706fdf&scoped=true"
import script from "./LinkCopyButton.vue?vue&type=script&lang=ts"
export * from "./LinkCopyButton.vue?vue&type=script&lang=ts"
import style0 from "./LinkCopyButton.vue?vue&type=style&index=0&id=09706fdf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09706fdf",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/link-copy-button.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2FLinkCopyButton.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports